import { call, put, takeLatest, all } from 'redux-saga/effects';

import { removeAPIError } from 'redux/apiErrors/sagas';

import { getCustomerLoyaltySummary } from './api';
import {
  GET_CUSTOMER_LOYALTY_SUMMARY_REQUEST,
  GET_CUSTOMER_LOYALTY_SUMMARY_SUCCESS,
  CUSTOMER_LOYALTY_SUMMARY_REQUESTING,
  RESET_CUSTOMER_LOYALTY_SUMMARY_ISFETCHING
} from './constants';

function* summary() {
  try {
    yield call(removeAPIError);
    yield put({ type: CUSTOMER_LOYALTY_SUMMARY_REQUESTING });
    const response = yield call(getCustomerLoyaltySummary);
    yield put({
      type: GET_CUSTOMER_LOYALTY_SUMMARY_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_CUSTOMER_LOYALTY_SUMMARY_ISFETCHING });
  }
}

function* watchList() {
  yield takeLatest(GET_CUSTOMER_LOYALTY_SUMMARY_REQUEST, summary);
}

export default function* customerLoyaltySummarySagas() {
  yield all([watchList()]);
}
